export const SESSION_KEY = "nextech_srp_draft_v1";
export const SRP_INFO_URL =
  "https://www.enisa.europa.eu/topics/product-security/single-reporting-platform-srp";

export const EU_MEMBER_STATES = Object.freeze([
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czechia",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
]);

export const STEPS = Object.freeze([
  { id: "setup", number: "0", de: "Fall & Fristen", en: "Case & deadlines" },
  { id: "h24", number: "1", de: "24h Early Warning", en: "24h Early Warning" },
  { id: "h72", number: "2", de: "72h Notification", en: "72h Notification" },
  { id: "final", number: "3", de: "Final Report", en: "Final Report" },
  { id: "transfer", number: "4", de: "Manueller SRP-Transfer", en: "Manual SRP transfer" },
]);

export const CHECKLIST_ITEMS = Object.freeze([
  ["eu_login", "EU Login und AR-Zugang geprüft", "EU Login and AR access checked"],
  ["manufacturer_assignment", "Korrekte Herstellerzuordnung geprüft", "Correct manufacturer assignment checked"],
  ["csirt", "Zuständigen CSIRT geprüft", "Designated CSIRT checked"],
  ["type_confirmed", "Meldetyp intern bestätigt", "Notification type internally confirmed"],
  ["awareness", "Kenntniserlangung samt Zeitzone und Nachweis dokumentiert", "Awareness time, timezone and evidence documented"],
  ["h24_open", "Für 24h „Submit new notification“ geöffnet", "For 24h, opened “Submit new notification”"],
  ["h24_values", "24h-Werte feldweise übertragen", "24h values transferred field by field"],
  ["h24_draft", "SRP-Draft gespeichert und gegen Copy-ready-Ansicht verglichen", "SRP draft saved and compared with the copy-ready view"],
  ["h24_review", "Vier-Augen-Review durchgeführt", "Four-eyes review completed"],
  ["h24_submitted", "24h extern eingereicht; Notification ID und tatsächliche Zeit protokolliert", "24h externally submitted; notification ID and actual time recorded"],
  ["h72_existing", "Für 72h bestehenden Notification Record geöffnet", "For 72h, opened the existing notification record"],
  ["h72_values", "72h-Werte übertragen, SRP-Validierungsfehler behoben und Review durchgeführt", "72h values transferred, SRP validation errors resolved and review completed"],
  ["h72_submitted", "72h extern eingereicht; tatsächliche Zeit protokolliert", "72h externally submitted; actual time recorded"],
  ["final_existing", "Für Final bestehenden Notification Record geöffnet", "For Final, opened the existing notification record"],
  ["final_values", "Final-Werte übertragen, SRP-Validierungsfehler behoben und Review durchgeführt", "Final values transferred, SRP validation errors resolved and review completed"],
  ["final_warning", "Warnung über Nicht-Editierbarkeit nach Final bestätigt", "Non-editability warning after Final confirmed"],
  ["final_submitted", "Final extern eingereicht; tatsächliche Zeit und sichere interne Archivierung protokolliert", "Final externally submitted; actual time and secure internal archiving recorded"],
]);

export const TEXT = Object.freeze({
  de: {
    badge: "Interne Vorbereitung · Keine Übertragung",
    architectureBadge: "Browser-only · 1 Fall · Kein PWA/Offline-Modus",
    singleCaseNote: "Der kostenlose Assistent verarbeitet genau einen Meldungsfall gleichzeitig; Import ersetzt den aktuellen Fall.",
    title: "CRA SRP Reporting Assistant",
    intro:
      "Dieses Tool bereitet Informationen für die manuelle Eingabe in die ENISA Single Reporting Platform vor. Es ist nicht mit ENISA verbunden, übermittelt keine Meldung und ersetzt weder die Live-SRP noch eine rechtliche oder technische Einzelfallprüfung.",
    premise:
      "Voraussetzung: Die Meldepflicht nach Art. 14 CRA wurde intern geprüft. Bei laufender Bewertung bitte als „Bewertung offen“ markieren.",
    privacy:
      "Security-by-Design: Formulardaten bleiben in dieser Browser-Sitzung, werden nicht an den Server gesendet und nicht dauerhaft gespeichert.",
    sessionNote: "Refresh-Schutz nur in diesem Tab über sessionStorage.",
    clear: "Sitzungsdaten löschen",
    clearConfirm: "Alle Eingaben dieser Browser-Sitzung wirklich löschen?",
    export: "JSON-Falldatei exportieren",
    reviewOpen: "Legal Review öffnen",
    import: "JSON importieren",
    exportWarning: "Die Falldatei kann hochsensible Cybersecurity-Informationen enthalten. Sicher speichern und teilen.",
    print: "Print View / Als PDF speichern",
    officialSources: "Offizielle Quellen und Stand",
    sourceNote: "ENISA FAQ Q15–Q18 und Guidance, zuletzt geprüft: 03.09.2026. Die Live-SRP und aktuelle ENISA-Guidance bleiben maßgeblich.",
    openInfo: "Offizielle ENISA-SRP-Informationsseite öffnen",
    noSend: "Dieser Klick sendet keine Daten.",
    setupTitle: "Fall anlegen und Fristen planen",
    setupIntro: "Interne Angaben; ausdrücklich nicht Teil der ENISA-Q16-Feldmatrix.",
    internalFields: "Interne Fallsteuerung",
    externalFields: "Externes SRP-Protokoll",
    reference: "Interne Fallreferenz",
    type: "Notification type",
    decision: "Status der internen Meldepflichtentscheidung",
    decisionOpen: "Bewertung offen",
    decisionConfirmed: "Meldepflicht intern bestätigt",
    awareness: "Zeitpunkt der Kenntniserlangung",
    timezone: "IANA-Zeitzone",
    awarenessBasis: "Grundlage / Nachweis der Kenntniserlangung",
    owner: "Interne fallverantwortliche Person",
    csirt: "Designated CSIRT (interne Routing-Hilfe)",
    srpId: "SRP Notification ID nach externer 24h-Einreichung",
    submitted24: "Tatsächliche externe Einreichzeit 24h",
    submitted72: "Tatsächliche externe Einreichzeit 72h",
    submittedFinal: "Tatsächliche externe Einreichzeit Final Report",
    measureAvailable: "Korrektur-/Minderungsmaßnahme verfügbar ab",
    continue: "Weiter",
    back: "Zurück",
    stageStatusReady: "Strukturell vollständig",
    stageStatusOpen: "Pflichtpunkte offen",
    automatedNote: "A-Felder werden von der SRP automatisiert und sind für den Submitter nicht sichtbar. Intern protokollierte Einreichzeiten sind getrennte Prozessfelder.",
    common: "Common fields",
    branchV: "Vulnerability",
    branchI: "Incident",
    guidance: "NexTech.Law Ausfüllhilfe",
    availability: "Verfügbarkeit",
    availabilityChoose: "Bitte entscheiden",
    availabilityYes: "Information verfügbar",
    availabilityNo: "Derzeit nicht verfügbar",
    evidence: "Quelle / Nachweis / Belegnotiz (niemals Copy-ready)",
    copy: "Copy-ready-Wert kopieren",
    copied: "Zuletzt kopiert",
    notCopied: "Noch nicht kopiert",
    inherited: "Aus Vorstufe übernommen",
    prior: "Vorwert verfügbar – Prüfung erforderlich",
    changed: "Vorstufe wurde geändert",
    refresh: "Aus Vorstufe aktualisieren",
    acceptPrior: "Vorwert prüfen und übernehmen",
    status: {
      complete: "ausgefüllt",
      missing: "Pflichtfeld offen",
      availability_decision_needed: "Verfügbarkeit klären",
      not_available_confirmed: "nicht verfügbar bestätigt",
      optional_blank: "optional",
      automated: "durch SRP automatisiert",
    },
    errorsTitle: "Strukturelle Prüfung: offene Punkte",
    deadlines: "Fristen (operative Planungshilfe)",
    deadline24: "24h Early Warning",
    deadline72: "72h Notification",
    deadlineFinal: "Final Report",
    local: "Lokal",
    utc: "UTC",
    notCalculable: "offen, Trigger fehlt",
    overdue: "überfällig",
    under6: "unter 6 Stunden",
    under24: "unter 24 Stunden",
    open: "offen",
    structural: "Strukturelle Vollständigkeit",
    transferTitle: "Manueller SRP-Transfer",
    transferIntro: "Die Einreichung erfolgt ausschließlich extern in der Live-SRP. Für 72h und Final öffnen Sie denselben Notification Record; legen Sie keinen neuen Fall an.",
    externalLog: "Externe SRP-Einreichung protokollieren",
    actualSubmit: "Tatsächliche externe Einreichzeit",
    notificationId: "Von der Live-SRP vergebene Notification ID",
    checklist: "Manuelle Transfer- und Vier-Augen-Checkliste",
    done: "erledigt",
    assignee: "Zuständig",
    note: "Notiz",
    completedAt: "Zeitpunkt",
    copyView: "Feldweise Copy-Ansicht",
    notAvailableCopy: "Hinweis: information not available — intern bestätigt; kein automatisch zulässiger SRP-Text.",
    finalWarning: "Warnung: Nach Übermittlung des Final Report ist die Notification laut ENISA-Guidance nicht mehr editierbar.",
    externalSubmitted: "Extern eingereicht",
    reviewWarning: "Review-Hinweis",
    deleteDone: "Sitzungsdaten wurden gelöscht.",
    importOk: "Falldatei wurde lokal importiert.",
    importFail: "Import abgelehnt",
    copyOk: "Wert kopiert und Zeitstempel protokolliert.",
    support: "Benötigen Sie kurzfristig CRA-SRP-Unterstützung?",
    supportBody: "NexTech.Law kann bei der internen Fallstruktur, Review und manuellen Übertragung unterstützen.",
    supportCta: "Erstgespräch buchen",
    faqTitle: "Häufige Fragen zur Vorbereitung",
  },
  en: {
    badge: "Internal preparation · No transmission",
    architectureBadge: "Browser-only · 1 case · No PWA/offline mode",
    singleCaseNote: "The free assistant processes exactly one reporting case at a time; importing replaces the current case.",
    title: "CRA SRP Reporting Assistant",
    intro:
      "This tool prepares information for manual entry into the ENISA Single Reporting Platform. It is not affiliated with ENISA, does not transmit a notification and replaces neither the live SRP nor legal or technical case review.",
    premise:
      "Prerequisite: your organisation has internally assessed whether Article 14 CRA reporting applies. If review is still running, mark it as “assessment open”.",
    privacy:
      "Security by design: form data remains in this browser session, is not sent to the server and is not stored persistently.",
    sessionNote: "Refresh protection only in this tab via sessionStorage.",
    clear: "Clear session data",
    clearConfirm: "Delete all entries from this browser session?",
    export: "Export JSON case file",
    reviewOpen: "Open Legal Review",
    import: "Import JSON",
    exportWarning: "The case file may contain highly sensitive cybersecurity information. Store and share it securely.",
    print: "Print view / Save as PDF",
    officialSources: "Official sources and status",
    sourceNote: "ENISA FAQ Q15–Q18 and guidance, last checked: 3 September 2026. The live SRP and current ENISA guidance remain authoritative.",
    openInfo: "Open the official ENISA SRP information page",
    noSend: "This click does not send any data.",
    setupTitle: "Create case and plan deadlines",
    setupIntro: "Internal data; expressly not part of the ENISA Q16 field matrix.",
    internalFields: "Internal case controls",
    externalFields: "External SRP log",
    reference: "Internal case reference",
    type: "Notification type",
    decision: "Internal reporting-duty decision status",
    decisionOpen: "Assessment open",
    decisionConfirmed: "Reporting duty internally confirmed",
    awareness: "Time of awareness",
    timezone: "IANA timezone",
    awarenessBasis: "Basis / evidence of awareness",
    owner: "Internal case owner",
    csirt: "Designated CSIRT (internal routing aid)",
    srpId: "SRP Notification ID after external 24h submission",
    submitted24: "Actual external 24h submission time",
    submitted72: "Actual external 72h submission time",
    submittedFinal: "Actual external Final Report submission time",
    measureAvailable: "Corrective/mitigating measure available from",
    continue: "Continue",
    back: "Back",
    stageStatusReady: "Structurally complete",
    stageStatusOpen: "Required items open",
    automatedNote: "A fields are automated by the SRP and not visible to the submitter. Internally recorded submission times are separate process fields.",
    common: "Common fields",
    branchV: "Vulnerability",
    branchI: "Incident",
    guidance: "NexTech.Law completion guidance",
    availability: "Availability",
    availabilityChoose: "Please decide",
    availabilityYes: "Information available",
    availabilityNo: "Currently not available",
    evidence: "Source / evidence / internal note (never copy-ready)",
    copy: "Copy copy-ready value",
    copied: "Last copied",
    notCopied: "Not copied yet",
    inherited: "Inherited from previous stage",
    prior: "Prior value available – review required",
    changed: "Previous stage was changed",
    refresh: "Update from previous stage",
    acceptPrior: "Review and accept prior value",
    status: {
      complete: "completed",
      missing: "required field open",
      availability_decision_needed: "clarify availability",
      not_available_confirmed: "not available confirmed",
      optional_blank: "optional",
      automated: "automated by SRP",
    },
    errorsTitle: "Structural review: open items",
    deadlines: "Deadlines (operational planning aid)",
    deadline24: "24h Early Warning",
    deadline72: "72h Notification",
    deadlineFinal: "Final Report",
    local: "Local",
    utc: "UTC",
    notCalculable: "open, trigger missing",
    overdue: "overdue",
    under6: "under 6 hours",
    under24: "under 24 hours",
    open: "open",
    structural: "Structural completeness",
    transferTitle: "Manual SRP transfer",
    transferIntro: "Submission happens exclusively externally in the live SRP. For 72h and Final, open the same notification record; do not create a new case.",
    externalLog: "Record external SRP submission",
    actualSubmit: "Actual external submission time",
    notificationId: "Notification ID assigned by the live SRP",
    checklist: "Manual transfer and four-eyes checklist",
    done: "done",
    assignee: "Owner",
    note: "Note",
    completedAt: "Timestamp",
    copyView: "Field-by-field copy view",
    notAvailableCopy: "Note: information not available — internally confirmed; no automatically permissible SRP text.",
    finalWarning: "Warning: according to ENISA guidance, the notification is no longer editable after the Final Report is submitted.",
    externalSubmitted: "Externally submitted",
    reviewWarning: "Review warning",
    deleteDone: "Session data has been deleted.",
    importOk: "Case file imported locally.",
    importFail: "Import rejected",
    copyOk: "Value copied and timestamp recorded.",
    support: "Need urgent CRA SRP support?",
    supportBody: "NexTech.Law can support internal case structure, review and manual transfer.",
    supportCta: "Book a call",
    faqTitle: "Frequently asked preparation questions",
  },
});
